import { JOURNAL_KINDS, LEDGER_ACCOUNT_KINDS } from "@platform/domain";
import { z } from "zod";
import { Id } from "../common/ids.js";
import { CurrencyCode, Money } from "../common/money.js";
import { PageQuery, page } from "../common/pagination.js";
import { Timestamp } from "../common/time.js";
import { defineRoute } from "../http/route.js";
/** The enterprise's view of the ledger (PAY-7, PAY-10, card 056): every movement on its own accounts. */
export const LedgerAccountKind = z.enum(LEDGER_ACCOUNT_KINDS).meta({ id: "LedgerAccountKind" });
export const JournalKind = z.enum(JOURNAL_KINDS).meta({ id: "JournalKind" });
export const StatementLine = z
    .object({
    entryId: Id,
    journalId: Id,
    at: Timestamp.describe("When the money moved"),
    kind: JournalKind.describe("`external_offline`: a bank transfer straight to the seller, outside Airwallex"),
    account: LedgerAccountKind,
    direction: z.enum(["debit", "credit"]),
    amount: Money,
    orderId: Id.nullable(),
    scheduleItemId: Id.nullable(),
    providerRef: z.string().nullable().describe("Airwallex's reference; null for a bank transfer"),
    externalReference: z.string().nullable().describe("The payer's bank reference, for a bank transfer"),
})
    .meta({ id: "StatementLine" });
export const StatementTotal = z
    .object({
    account: LedgerAccountKind,
    currency: CurrencyCode,
    debits: Money,
    credits: Money,
})
    .meta({ id: "StatementTotal" });
export const getLedgerStatement = defineRoute({
    surface: "tenant",
    auth: "user",
    permission: "ledger:read",
    id: "payment.ledger.statement",
    method: "GET",
    path: "/v1/ledger/statement",
    marks: ["tenant"],
    summary: "The enterprise's movements on its own ledger accounts, newest first, optionally in one currency and between two dates (inclusive, UTC), with the totals of the range per account and currency",
    prd: ["PAY-7", "PAY-10"],
    request: {
        query: PageQuery.extend({
            currency: CurrencyCode.optional(),
            from: z.iso.date().optional(),
            to: z.iso.date().optional(),
        }),
    },
    responses: {
        200: {
            description: "The statement",
            schema: page(StatementLine).extend({ totals: z.array(StatementTotal) }),
        },
    },
    errors: ["AUTH_REQUIRED", "TENANT_REQUIRED", "PERMISSION_DENIED", "VALIDATION_FAILED"],
});
export const ledgerRoutes = [getLedgerStatement];
//# sourceMappingURL=ledger.routes.js.map